module.exports = __webpack_public_path__ + "img/how_it_works_3.a81870ce.jpg";